var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "88", height: "88", viewBox: "0 0 88 88" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("circle", { id: "id-94a", cx: "44", cy: "44", r: "44" })
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { opacity: ".07" },
        React.createElement("use", { fill: "#FFF", xlinkHref: "#id-94a" }),
        React.createElement("use", { fill: "#D0021B", xlinkHref: "#id-94a" })
      ),
      React.createElement(
        "g",
        { transform: "translate(14 18.999)" },
        React.createElement("path", { fill: "#606060", d: "M26.667.001C29.612.001 32 2.39 32 5.334v15.998c0 2.946-2.388 5.333-5.333 5.333H7.847l-4.812 4.812C1.915 32.597 0 31.804 0 30.22V5.334C0 2.39 2.388.001 5.333.001h21.334z", transform: "translate(15 12)" }),
        React.createElement("path", { fill: "#FFF", fillRule: "nonzero", d: "M2 5.501v24.5l4.737-4.737c.329-.328.774-.513 1.238-.513H26.5c1.933 0 3.5-1.567 3.5-3.5V5.501c0-1.933-1.567-3.5-3.5-3.5h-21c-1.933 0-3.5 1.567-3.5 3.5z", transform: "translate(15 12)" }),
        React.createElement("path", { fill: "#D0021B", fillRule: "nonzero", d: "M52 2.001c.552 0 1 .359 1 .8v2.2h2.2c.442 0 .8.448.8 1 0 .553-.358 1-.8 1H53v2.2c0 .442-.448.8-1 .8s-1-.358-1-.8v-2.2h-2.2c-.442 0-.8-.447-.8-1 0-.552.358-1 .8-1H51V2.8c0-.441.448-.8 1-.8z", transform: "rotate(45 52 6.001)" }),
        React.createElement("circle", { cx: "50.503", cy: "42.505", r: "1.503", fill: "#D0021B", fillRule: "nonzero" }),
        React.createElement("circle", { cx: "19.503", cy: "4.505", r: "1.503", fill: "#D0021B", fillRule: "nonzero" }),
        React.createElement("path", { fill: "#D0021B", fillRule: "nonzero", d: "M6.226 37.227c.552 0 1 .448 1 1l-.001 2.225 2.227.001c.512 0 .935.386.993.883l.007.117c0 .552-.448 1-1 1H7.225v2.226c0 .513-.385.935-.883.993l-.116.007c-.552 0-1-.448-1-1l-.001-2.227L3 42.453c-.513 0-.936-.386-.993-.883L2 41.453c0-.552.448-1 1-1h2.225v-2.226c0-.513.387-.935.884-.993z", transform: "rotate(45 6.226 41.453)" })
      ),
      React.createElement(
        "g",
        { fill: "#D0021B", transform: "translate(44 38)" },
        React.createElement("path", { stroke: "#D0021B", strokeWidth: ".5", d: "M1 0c.56 0 1.015.455 1.015 1.015 0 .023 0 .046-.002.07L1.58 7.457C1.56 7.763 1.306 8 1 8c-.306 0-.56-.237-.58-.542l-.433-6.374C-.051.524.372.04.93.002L1 0z" }),
        React.createElement("circle", { cx: "1", cy: "11", r: "1" })
      )
    )
  );
});